/* global axios */
import ApiClient from '../ApiClient';

// U3 converter. The server report is authoritative; nothing is written
// without an explicit create call after the user saw that report.
class TeletelAutomationConversionsAPI extends ApiClient {
  constructor() {
    super('automation-conversions', { accountScoped: true });
  }

  baseUrl() {
    return `/teletel${super.baseUrl()}`;
  }

  preview(ruleId) {
    return axios.post(`${this.url}/preview`, { rule_id: ruleId });
  }

  convert(ruleId) {
    return axios.post(this.url, { rule_id: ruleId });
  }
}

export default new TeletelAutomationConversionsAPI();
